import { AppState } from '../../common/configuration/app.states';

export const getConnectedUser = (state: AppState) => state.auth.connectedUser;

export const getLoading = (state: AppState) => state.auth.loading;

export const getAuthTokens = (state: AppState) => state.auth.authTokens;
